'use strict';

define(['jquery', 'siteObj', 'handlebars', 'quickViewTpl', 'fancyBox', 'enhancedEcommerce', 'quickViewTracking', 'app', 'ajaxBasket', 'module'], function ($, siteObj, handlebars, quickViewTpl, fancybox, enhancedEcommerce, quickViewTracking, app) {

  var module = arguments[arguments.length - 1],
      quickview = {
    init: function init(config) {
      quickview.events(config);
    },
    events: function events(config) {
      if (config !== false && $(config.selectors.trigger).length) {
        $(config.selectors.trigger).click(function (e, el) {
          var $qvLink = $(this);
          var $cItem = $qvLink.closest('.item');
          var sku = $cItem[0].getAttribute('data-product-id') || $cItem[0].attributes.rel.value;
          //return data taken from clicked item
          if (siteObj.features.enhancedEcommerce === 'true') {
            quickViewTracking.getData($cItem, config);
          }
          //set endpoint url
          if (siteObj.page === 'basket' && siteObj.section === 'checkout') {
            config.endpoint = siteObj.siteSecureURL + siteObj.siteDefaultLocale + '/' + siteObj.currencyType + '/' + siteObj.shippingCountry + '/' + sku + '.fullproductdata';
          } else {
            config.endpoint = siteObj.siteNonSecureURL + siteObj.siteCode + '/' + siteObj.siteDefaultLocale + '/' + siteObj.currencyType + '/' + siteObj.shippingCountry + '/' + sku + '.fullproductdata';
          }

          //call qv fancybox
          quickview.popover.init(config, sku);
          return false;
        });
      }
    },
    render: function render(data, config) {

      if (siteObj.page === 'basket') {
        data.secureqv = true;
      }

      data.index = config.index || 0;
      data.id = config.id || '';
      data.isMasterProduct = config.isMasterProduct || '';
      data.brand = config.brand || '';

      var content = quickViewTpl(data);
      quickview.popover.populate(content);
    },
    popover: {
      init: function init(config, sku) {
        $.fancybox.defaults.afterShow = function () {
          if (siteObj.features.enhancedEcommerce) {
            enhancedEcommerce.clearSiteObjValues();
            quickViewTracking.addTracking();
          }
          $(config.selectors.wrap).on('click', function (e) {
            $.fancybox.close();
            e.preventDefault();
          });

          // trigger a variations request to account for an unavailable preselected variation
          var s = $('.fancybox-inner select:first');
          if (s) {
            s.trigger('change');
          }
        };

        $.fancybox.defaults.beforeClose = function () {
          if (siteObj.features.enhancedEcommerce) {
            enhancedEcommerce.clearSiteObjValues();
            quickViewTracking.removeTracking();
          }
        };

        quickview.request(config, sku);
      },
      populate: function populate(content) {
        $.fancybox(content, $.extend($.fancybox.defaults, module.config()));
      },
      error: function error(content) {
        $.fancybox(content, $.extend($.fancybox.defaults, module.config()));
      }
    },
    request: function request(config) {
      $.ajax({
        url: config.endpoint,
        success: function success(result) {
          //Linting fixes.
          result.props = siteObj.props;
          if (result.productVariations && result.productVariations.length) {
            result.productVariations[0].first = true;
          }
          quickview.render(result, config);
        },
        error: function error() {
          quickview.popover.error(config.errorContent);
        }
      });
    }
  };
  var loadingGif, qvInit;
  if (siteObj.page === 'basket' && siteObj.section === 'checkout') {
    loadingGif = 'https:' + siteObj.siteURL + 'common/images/loading.gif';
  } else {
    loadingGif = siteObj.siteNonSecureURL + siteObj.loadingGifPath;
  }

  //Put QV required params into variable to be used multiple times.
  qvInit = {
    'selectors': {
      'trigger': module.config().quickviewtrigger || '.icon-quickview, .quickview, .quickbuy, .quickview-buy',
      'wrap': module.config().quickviewWrap || '.product-quick-view .close-fb'
    },
    'initialContent': '<div class=\'basketAlert\'><img src=' + loadingGif + ' alt=\'Loading\' class=\'fb-loader\' /></div>',
    'errorContent': '<div class=\'quickViewAlert\'><p>' + siteObj.props.ajaxBasket.errors.basketError + '</p></div>'
  };

  //Initiate standard QV call.
  quickview.init(qvInit);

  //Subscribe to ajax success call to ensure QV click function works after AJAX call.
  app.subscribe('ajaxSuccess/quickView', function () {
    quickview.init(qvInit);
  });

  return quickview;
});
//# sourceMappingURL=quick-view.js.map
